import { Theme } from "@sodraberget/shared";
import { Dimensions, StyleSheet } from "react-native";

const mapPanelStyle = (theme: Theme) => {
    const {width} = Dimensions.get('window');

    return StyleSheet.create({
        container: {
            //
        },
        map: {
            width: '100%',
            height: '100%',
            minWidth: width < 2 * 420 
                ? 420 
                : width < 420
                ? theme.units.vw
                : undefined,
        },
        gradient: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: 4.8 * theme.units.base,
        },
        controlsColumn: {
            position: 'absolute',
            right: 32,
            bottom: 24,
            alignItems: 'flex-end',
            gap: 8,
        },
        zoom: {
            alignSelf: 'flex-end',
        },
        mapSelectorWrap: {
            alignItems: 'flex-end',
            maxWidth: theme.units.base * 22,
        },
        typeFilterWrap: {
            alignItems: 'flex-end',
            maxWidth: theme.units.base * 22,
        },
        mapSelectorCard: {
            position: 'absolute',
            right: 76,
            bottom: 0,
            backgroundColor: '#ffffff',
            borderRadius: 14,
            paddingVertical: 14,
            paddingHorizontal: 18,
            width: 306,
            minHeight: 250,
        },
        mapSelectorTitle: {
            fontSize: 14,
            fontWeight: '700',
            color: theme.color.textLink,
            marginBottom: 8,
        },
        mapTypeGrid: {
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        mapTypeButton: {
            width: 60,
            alignItems: 'center',
            justifyContent: 'center',
        },
        mapTypeButtonActive: {
            opacity: 1,
        },
        mapTypePreviewFrame: {
            width: 52,
            height: 52,
            marginBottom: 8,
        },
        mapTypeActiveMarker: {
            position: 'absolute',
            top: 4,
            left: 4,
            width: 52,
            height: 52,
            borderRadius: 4,
            backgroundColor: '#ff4040',
        },
        mapTypePreview: {
            width: 52,
            height: 52,
            borderRadius: 4,
            backgroundColor: '#ffffff',
            borderWidth: 2,
            borderColor: theme.color.textLink,
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 4,
            overflow: 'hidden',
        },
        mapTypePreviewBorderless: {
            borderWidth: 0,
        },
        mapTypePreviewImage: {
            width: 46,
            height: 46,
        },
        mapTypePreviewActive: {
            borderColor: theme.color.textLink,
            backgroundColor: theme.color.listBackground,
            borderWidth: 3,
        },
        mapTypeButtonText: {
            fontSize: 10,
            fontWeight: '700',
            color: theme.color.textLink,
            textAlign: 'center',
        },
        mapTypeButtonTextActive: {
            color: theme.color.textLink,
        },
        mapSettingsDivider: {
            height: 1,
            backgroundColor: theme.color.textLink,
            marginVertical: 12,
        },
        mapSettingsTitle: {
            fontSize: 14,
            color: theme.color.textLink,
            marginBottom: 8,
        },
        directionButton: {
            width: 60,
            alignItems: 'center',
        },
        directionArrows: {
            width: 32,
            height: 32,
            justifyContent: 'center',
        },
        directionArrowBack: {
            width: 22,
            height: 16,
            color: theme.color.textLink,
            alignSelf: 'flex-start',
        },
        directionArrowForward: {
            width: 22,
            height: 16,
            color: theme.color.textLink,
            alignSelf: 'flex-end',
        },
        directionRow: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        directionCheck: {
            width: theme.iconSize.medium,
            height: theme.iconSize.medium,
            borderRadius: theme.borderRadius.standard / 2,
            borderWidth: 1,
            borderColor: theme.color.textSecondary,
            backgroundColor: theme.color.listEntryBackground,
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: theme.spacing.half,
        },
        directionCheckActive: {
            borderColor: theme.color.textLink,
        },
        directionCheckFill: {
            width: theme.iconSize.extraSmall,
            height: theme.iconSize.extraSmall,
            borderRadius: theme.borderRadius.standard / 4,
            backgroundColor: theme.color.textLink,
        },
        directionText: {
            fontSize: theme.fontSize.small,
            color: theme.color.textPrimary,
        },
        mapSelectorToggle: {
            backgroundColor: theme.color.listBackground,
            borderWidth: 1,
            borderColor: theme.color.textSecondary,
            borderRadius: theme.borderRadius.large,
            paddingHorizontal: theme.spacing.standard,
            paddingVertical: theme.spacing.half,
        },
        mapSelectorToggleOpen: {
            borderColor: theme.color.textLink,
        },
        mapSelectorToggleText: {
            fontSize: theme.fontSize.small,
            color: theme.color.textPrimary,
        },
        typeFilterCard: {
            backgroundColor: theme.color.listBackground,
            borderRadius: theme.borderRadius.large,
            borderWidth: 1,
            borderColor: theme.color.textSecondary,
            padding: theme.spacing.standard,
            width: theme.units.base * 22,
            marginBottom: theme.spacing.sliver,
            maxHeight: theme.units.base * 24,
        },
        typeFilterTitle: {
            fontSize: theme.fontSize.small,
            marginBottom: theme.spacing.half,
            color: theme.color.textPrimary,
        },
        typeFilterSectionTitle: {
            fontSize: theme.fontSize.small,
            color: theme.color.textSecondary,
            flex: 1,
        },
        typeFilterSectionHeader: {
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: theme.spacing.half,
            marginBottom: theme.spacing.sliver,
        },
        typeFilterSectionArrow: {
            color: theme.color.textSecondary,
            width: theme.iconSize.small,
            height: theme.iconSize.small,
            transform: [{ rotate: '-90deg' }],
        },
        typeFilterSectionArrowOpen: {
            transform: [{ rotate: '0deg' }],
        },
        typeFilterOptionsGrid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginHorizontal: -theme.spacing.sliver,
        },
        typeFilterIconButton: {
            width: '48%',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: theme.borderRadius.standard / 2,
            paddingHorizontal: theme.spacing.half,
            paddingVertical: theme.spacing.sliver,
            marginBottom: theme.spacing.sliver,
            marginHorizontal: '1%',
            minHeight: theme.units.base * 3,
            borderWidth: 1,
            borderColor: theme.color.textSecondary,
            backgroundColor: theme.color.listBackground,
        },
        typeFilterIconButtonActive: {
            backgroundColor: theme.color.listEntryBackground,
            borderColor: theme.color.textLink,
        },
        typeFilterIcon: {
            width: theme.iconSize.small,
            height: theme.iconSize.small,
            marginRight: theme.spacing.half,
            color: theme.color.textPrimary,
        },
        typeFilterIconText: {
            flex: 1,
            fontSize: theme.fontSize.small,
            color: theme.color.textPrimary,
        },
        typeFilterResetButton: {
            marginTop: theme.spacing.half,
            alignSelf: 'flex-end',
            paddingHorizontal: theme.spacing.half,
            paddingVertical: theme.spacing.sliver,
        },
        typeFilterResetText: {
            fontSize: theme.fontSize.small,
            color: theme.color.textLink,
        },
        typeFilterToggle: {
            backgroundColor: theme.color.listBackground,
            borderWidth: 1,
            borderColor: theme.color.textSecondary,
            borderRadius: theme.borderRadius.large,
            paddingHorizontal: theme.spacing.standard,
            paddingVertical: theme.spacing.half,
        },
        typeFilterToggleOpen: {
            borderColor: theme.color.textLink,
        },
        typeFilterToggleText: {
            fontSize: theme.fontSize.small,
            color: theme.color.textPrimary,
        },
        filterControlWrap: {
            alignItems: 'center',
            gap: theme.spacing.sliver,
        },
        filterControlWrapOpen: {
            // Wide enough for two columns of 28px buttons when the menu wraps.
            maxWidth: 76,
            padding: 4,
            gap: 8,
            borderRadius: 20,
            backgroundColor: '#ffffff',
        },
        filterFab: {
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: '#ffffff',
            alignItems: 'center',
            justifyContent: 'center',
        },
        filterFabOpen: {
            backgroundColor: '#ffffff',
        },
        filterFabIcon: {
            width: 26,
            height: 26,
            color: theme.color.textLink,
        },
        filterFabIconOpen: {
            color: theme.color.textLink,
        },
        filterIconMenu: {
            gap: 8,
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            paddingTop: 4,
        },
        filterIconMenuButton: {
            width: 28,
            height: 28,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.borderRadius.standard,
            borderWidth: 2,
            borderColor: theme.color.textLink,
            backgroundColor: theme.color.listEntryBackground,
        },
        filterIconMenuButtonPathActive: {
            backgroundColor: theme.color.listEntryBackground,
            borderColor: theme.color.textLink,
        },
        filterIconMenuButtonPoiActive: {
            backgroundColor: theme.color.mapIcons,
            borderColor: theme.color.mapIcons,
        },
        filterIconMenuButtonInactive: {
            opacity: 0.35,
            backgroundColor: theme.color.listEntryBackground,
        },
        filterIconMenuButtonPoiInactive: {
            opacity: 0.35,
            backgroundColor: theme.color.mapIcons,
            borderColor: theme.color.mapIcons,
        },
        filterIconMenuIcon: {
            width: '80%',
            height: '80%',
            color: theme.color.textLink,
        },
        filterIconMenuIconPathActive: {
            color: theme.color.textLink,
        },
        filterIconMenuIconPoiActive: {
            color: '#ffffff',
        },
        filterIconMenuIconInactive: {
            color: theme.color.textLink,
        },
        filterIconMenuIconPoiInactive: {
            color: '#ffffff',
        },
        toolDock: {
            alignItems: 'center',
            gap: theme.spacing.sliver,
        },
        zoomDock: {
            borderRadius: 20,
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            width: 40,
        },
        zoomDockButton: {
            backgroundColor: '#ffffff',
            width: '100%',
            height: 42,
            alignItems: 'center',
            justifyContent: 'center',
        },
        zoomButtonText: {
            textAlign: 'center',
            fontSize: 38,
            lineHeight: 42,
            color: theme.color.textLink,
            fontWeight: '700',
        },
        zoomDivider: {
            height: 1,
            backgroundColor: theme.color.textSecondary,
        },
        loadingOverlay: {
            position: 'absolute',
            backgroundColor: 'white',
            width: '100%',
            height: '100%',
            opacity: 0.5,
            textAlign: 'center',
            justifyContent: 'center',
        },
        spinner: {
            flex: 1,
            width: '100%',
            height: '100%',
        },
    });
};

export { mapPanelStyle };